import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {Http, Response} from '@angular/http';
import {constant} from '../../app.constants';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {map} from 'rxjs/operators';
import { RiderInterface} from '../interfaces/rider.interface';
import { IRiderSignature } from '../interfaces/rider-signature.interface';

import {IResponseSuccess, ResponseInterface} from '../interfaces/response.interface';


@Injectable()
export class RiderService extends ParentService {

  private riderInformation = new BehaviorSubject<RiderInterface>(null);
  riderInformation$ = this.riderInformation.asObservable();

  constructor(private _http: Http) {
    super();
  }

  getDataRider(data: RiderInterface) {
    this.riderInformation.next(data);
  }

  /**
   * @type get
   * @param id = riderid
   * @description trae la información del Rider
   * */
  get(id: number, inactive?: boolean): Observable<RiderInterface> {
    let url = `${constant.URL_RIDER}/${id}`;
    inactive ? url += `?includeInactive=${inactive}` : null;
    return this._http.get(url, this.getHeader())
      .pipe(
        map((response: any) => response.json() as RiderInterface)
      );
  }

  /**
   * @type post
   * @param rider
   * @description add rider
   */
  post(rider: RiderInterface): Observable<ResponseInterface> {
    const body = JSON.stringify(rider);
    return this._http.post(constant.URL_RIDER, body, this.headerPost())
      .pipe(
        map(( response: any) => response.json() as ResponseInterface)
    ).catch((error: any) => Observable.throw(error.json()));
  }

  put(rider: RiderInterface): Observable<ResponseInterface> {
    const body = JSON.stringify(rider);
    return this._http.put(constant.URL_RIDER, body, this.headerPost())
      .pipe(
        map((response: any) => response.json as ResponseInterface)
    ).catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description traer codigo QR de info del rider
   */
  getQR(riderId: number): Observable<any> {
    return this._http.get(`${constant.URL_RIDER_QR}/${riderId}`, this.getFileHeaders()).map(
      (res: Response) => res
    ).catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description traer codigo de registro del rider
   */
  getCodeRider(riderId: number): Observable<number> {
    return this._http.get(`${constant.URL_RIDER_CODE}/${riderId} `, this.getHeader()).pipe(
        map((response: any) => response.json() )
      );
  }

  getRiderLanguage(): Observable<any> {
    return this._http
      .get(constant.URL_GET_LANGUAGE, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getSignaturesByRiderId(
    riderId: number,
    showInactive: boolean = false,
  ): Observable<IRiderSignature[]> {
    const url = `${constant.URL_GET_SIGNATURES_BY_RIDER}${riderId}?showInactive=${showInactive}`;
    return this._http
      .get(url, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateRiderSignatureExpiration(
    signature: IRiderSignature,
  ): Observable<any> {
    const body = JSON.stringify(signature);
    return this._http
      .put(constant.URL_UPDATE_SIGNATURE, body, this.headerPost())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  resetSignatureById(signatureId: number): Observable<any> {
    return this._http
      .put(`${constant.URL_RESET_SIGNATURE_BY_ID}${signatureId}`, {}, this.headerPost())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  verifyEmail(token: string): Observable<IResponseSuccess> {
    return this._http
      .patch(constant.URL_RIDER_VERIFY_EMAIL, { token })
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  sendVerifyEmail(riderId: number): Observable<IResponseSuccess> {
    return this._http
      .post(constant.URL_RIDER_SEND_VERIFY_EMAIL, { riderId }, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/rider.service.ts